<template>
  <v-list-group
    :value="false"
    no-action
    sub-group
  >
    <template v-slot:prependIcon>
      <v-icon color="secondary">mdi-menu-down</v-icon>
    </template>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title class="secondary--text">{{item.title}}</v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item
       v-for="subItem in item.children"
      :key="subItem.icon"
      link
      :to="routeToItem(subItem)" :title="subItem.title" exact
    >
      <v-list-item-title class="secondary--text">{{subItem.title}}</v-list-item-title>
      <v-list-item-icon>
        <v-icon color="secondary">{{subItem.icon}}</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </v-list-group>
</template>

<script>
export default {
  
  name: 'Admin_Structure_MenuSubNode',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    routeToItem(item) {
      if (item.name) {
        return { name: item.name };
      }
      return { path: item.path };
    },
  }

}
</script>